<div #plot [attr.id]="divId" [className]="getClassName()" [ngStyle]="style"></div>